import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PreLoginStoriesPage } from './pre-login-stories';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';
import { LottieAnimationViewModule } from 'ng-lottie';
import { TabsHomePageModule } from '../tabs-home/tabs-home.module' // preload the page to speed up during biometrics login

@NgModule({
  declarations: [
    PreLoginStoriesPage,
  ],
  imports: [
    IonicPageModule.forChild(PreLoginStoriesPage),
    LottieAnimationViewModule.forRoot(),
    ComponentsModule,
    PipesModule,
    TabsHomePageModule,
  ],
  providers:[]
})
export class PreLoginStoriesPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/pre-login-stories/pre-login-stories.module.ts